import React from "react";
import { connect } from "react-redux";

import { uploadFile, getFiles, getFolders, setFolder } from "./actions";
import { ArrowBackIos as BackIcon } from "@material-ui/icons";

import {
    Chip,
    Grid,
    Button,
    List,
    ListItem,
    ListItemText,
    withStyles,
    Switch,
    Checkbox,
    TextField,
    Typography,
    ListItemSecondaryAction,
} from "@material-ui/core";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    selectedFolder,
    selectFiles,
    selectCurrNames,
    selectFolders,
    getAllFiles
} from "./selectors";

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        "&$checked": {
            transform: "translateX(12px)",
            color: theme.palette.common.white,
            "& + $track": {
                opacity: 1,
                backgroundColor: "#0188cc",
                borderColor: "#0188cc",
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: "none",
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);
const CustomCheckbox = withStyles({
    root: {
        color: "#0188cc",
        "&$checked": {
            color: "#0188cc",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);
export class FileUploader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadFiles: [],
            uploadedFiles: false,
            duplicates: {},
            maxSizeExceeded: [],
            error: false,
            finished: false,
            msg: false,
            progress: false,
            selectedFiles: [],
        };
        props.getFiles();
        props.getFolders();
        props.setFolder();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            this.props.setFolder();
            this.setState({
                uploadFiles: [],
                uploadedFiles: false,
                duplicates: {},
                maxSizeExceeded: [],
                error: false,
                finished: false,
                msg: false,
                progress: false,
                selectedFiles: [],
            });
        }
    }
    isDuplicate(newFiles, currFiles) {
        if (currFiles && newFiles && newFiles.length !== 0) {
            let currNames = Object.keys(currFiles).map(
                (e) => currFiles[e].file_name
            );
            let newNames = Object.keys(newFiles).map((e) => {
                return { name: newFiles[e].name, uid: e };
            });
            let duplicateIDs = {};
            newNames.map((e) => {
                if (currNames.includes(e.name))
                    duplicateIDs = { ...duplicateIDs, [e.uid]: e.name };
                return null;
            });
            return Object.keys(duplicateIDs).length <= 0 ? {} : duplicateIDs;
        } else {
            return {};
        }
    }
    isSubmitDisabled(names, dups) {
        let flag = false;
        Object.keys(dups).map((e) => {
            if (names.includes(dups[e])) flag = true;
            return null;
        });
        return flag;
    }
    isSelected(obj) {
        const { selectedFiles } = this.state;
        let selected = selectedFiles.map((e) => e.file);
        return selected.includes(obj.file);
    }
    areFileSizesTooLarge = (files) => {
        let exceeded = [];
        Object.keys(files).map((index) =>
            files[index].size > 10000000 ? exceeded.push(index) : null
        );
        return exceeded;
    };
    getFilesList(files = false) {
        if (files) {
            return (
                <List
                    style={{
                        maxHeight: "500px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                    }}
                >
                    <ListItem
                        button
                        onClick={() => {
                            this.props.setFolder(false);
                        }}
                    >
                        <ListItemText
                            primary={
                                <>
                                    <BackIcon /> Back
                                </>
                            }
                        />
                    </ListItem>
                    <Typography
                        style={{
                            marginTop: 24,
                            fontWeight: "bold",
                        }}
                        variant="body2"
                    >
                        (2) Select File
                    </Typography>
                    {Object.keys(files).map((id) => {
                        let obj = {
                            file: files[id].file_name,
                            file_type: files[id].file_folder,
                            fileURL: files[id].file_url,
                        };
                        return (
                            <ListItem
                                button
                                style={{ color: "black" }}
                                onClick={() => {
                                    if (this.isSelected(obj)) {
                                        let selFiles = this.state.selectedFiles.filter(
                                            (e) => e.file !== obj.file
                                        );

                                        this.setState({
                                            selectedFiles: selFiles,
                                        });
                                    } else {
                                        let selFiles = this.state.selectedFiles;
                                        selFiles.push(obj);

                                        this.setState({
                                            ...this.state,
                                            selectedFiles: selFiles,
                                        });
                                    }
                                }}
                            >
                                <ListItemText primary={files[id].file_name} />
                                <ListItemSecondaryAction>
                                    <CustomCheckbox
                                        checked={this.isSelected(obj)}
                                        value={`${id}`}
                                        onClick={() => {
                                            if (this.isSelected(obj)) {
                                                let selFiles = this.state.selectedFiles.filter(
                                                    (e) => e.file !== obj.file
                                                );

                                                this.setState({
                                                    selectedFiles: selFiles,
                                                });
                                            } else {
                                                let selFiles = this.state
                                                    .selectedFiles;
                                                selFiles.push(obj);

                                                this.setState({
                                                    ...this.state,
                                                    selectedFiles: selFiles,
                                                });
                                            }
                                        }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        );
                    })}
                </List>
            );
        } else {
            return <Typography>No Files Available</Typography>;
        }
    }
    getFolderList(folders = false) {
        if (folders) {
            return (
                <>
                    <Typography
                        style={{
                            fontWeight: "bold",
                        }}
                        variant="body2"
                    >
                        (1) Select Folder
                    </Typography>
                    <List
                        style={{
                            maxHeight: "500px",
                            overflowY: "scroll",
                            overflowX: "hidden",
                        }}
                    >
                        {Object.keys(folders).map((id) => {
                            return (
                                <ListItem
                                    button
                                    style={{
                                        color: "black",
                                        borderLeft:
                                            this.props.selectedFolder === id
                                                ? "2px solid #0188cc"
                                                : "0px",
                                    }}
                                    onClick={() => {
                                        this.props.setFolder(id);
                                    }}
                                >
                                    <ListItemText primary={folders[id]} />
                                </ListItem>
                            );
                        })}
                    </List>
                </>
            );
        } else {
            return <Typography>No Folders Available</Typography>;
        }
    }
    switcherChange = (event) => {
        this.props.setFolder();
        this.setState({ [event.target.name]: event.target.checked });
    };
    render() {
        const {
            selectedFolder,
            files,
            allFiles,
            currNames,
            folders,
            permittedFileType = false,
            isOpen = false,
            closeFileUploader,
            multipleUploads = false,
            uploadFilesOnly = false,
        } = this.props;
        console.log(allFiles,"allFiles")
        console.log(files,"files")
        const {
            progress,
            error,
            finished,
            msg,
            maxSizeExceeded,
            duplicates,
            uploadFiles,
            fileView,
            selectedFiles,
        } = this.state;

        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>File Uploader</ModalHeader>

                <ModalBody>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {!uploadFilesOnly && (
                                <Typography
                                    component="div"
                                    style={{
                                        maxWidth: "60%",
                                        margin: "0 auto",
                                        position: "relative",
                                        fontWeight: "bold",
                                    }}
                                >
                                    <Grid
                                        component="label"
                                        container
                                        alignItems="center"
                                        spacing={1}
                                    >
                                        <Grid item>Select Existing File</Grid>
                                        <Grid item>
                                            <AntSwitch
                                                checked={this.state.fileView}
                                                onChange={this.switcherChange}
                                                name="fileView"
                                            />
                                        </Grid>
                                        <Grid item>Upload Files</Grid>
                                    </Grid>
                                </Typography>
                            )}
                        </Grid>
                        {!uploadFilesOnly && !fileView && (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                {!selectedFolder && this.getFolderList(folders)}
                                {selectedFolder && this.getFilesList(files)}
                            </Grid>
                        )}
                        {(uploadFilesOnly || fileView) && (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                {this.getFolderList(folders)}
                                {maxSizeExceeded.length > 0 && (
                                    <Typography
                                        style={{
                                            color: "red",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Some files that have been selected
                                        cannot be uploaded as they exceed 10mb!
                                        Please try again.{" "}
                                    </Typography>
                                )}
                                <Typography
                                    style={{
                                        marginTop: 24,
                                        fontWeight: "bold",
                                    }}
                                    variant="body2"
                                >
                                    (2) Selected Files
                                </Typography>
                                <List>
                                    {uploadFiles &&
                                        Object.keys(uploadFiles).map((id) => {
                                            if (!maxSizeExceeded.includes(id))
                                                return (
                                                    <ListItem
                                                        style={{
                                                            border: duplicates[
                                                                id
                                                            ]
                                                                ? "2px solid red"
                                                                : "2px solid green",
                                                            margin: 4,
                                                            borderRadius: 8,
                                                        }}
                                                    >
                                                        {!duplicates[id] ? (
                                                            <ListItemText
                                                                primary={
                                                                    uploadFiles[
                                                                        id
                                                                    ].name
                                                                }
                                                            />
                                                        ) : (
                                                            <>
                                                                <TextField
                                                                    error={true}
                                                                    value={
                                                                        duplicates[
                                                                            id
                                                                        ]
                                                                    }
                                                                    fullWidth
                                                                    label={
                                                                        "Name Duplication. Please rename file before uploading"
                                                                    }
                                                                    onChange={(
                                                                        ev
                                                                    ) => {
                                                                        let dups = duplicates;
                                                                        dups[
                                                                            id
                                                                        ] =
                                                                            ev.target.value;
                                                                        this.setState(
                                                                            {
                                                                                duplicates: dups,
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                    </ListItem>
                                                );
                                            else return null;
                                        })}
                                </List>
                                <Button
                                    style={{
                                        margin: "0 auto",

                                        display: "block",

                                        width: "100%",
                                        background: "#0188cc",
                                        color: "white",
                                    }}
                                    disabled={selectedFolder === false}
                                    onClick={() => {
                                        this.fileInput.click();
                                    }}
                                    variant="contained"
                                >
                                    Select File(s)
                                </Button>
                                {(progress || error || finished) && (
                                    <Chip
                                        label={msg}
                                        style={{
                                            width: "100%",
                                            textAlign: "center",
                                            background: progress
                                                ? "orange"
                                                : error
                                                ? "red"
                                                : finished
                                                ? "green"
                                                : "grey",
                                        }}
                                    />
                                )}
                                <input
                                    accept={
                                        permittedFileType
                                            ? permittedFileType
                                            : "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
                                    }
                                    multiple={multipleUploads}
                                    type="file"
                                    onChange={(event) => {
                                        let dups = this.isDuplicate(
                                            event.target.files,
                                            files
                                        );
                                        let sizeExceeded = this.areFileSizesTooLarge(
                                            event.target.files
                                        );
                                        this.setState({
                                            uploadFiles: event.target.files,
                                            duplicates: dups,
                                            maxSizeExceeded: sizeExceeded,
                                        });
                                    }}
                                    style={{
                                        display: "none",
                                    }}
                                    ref={(fileInput) =>
                                        (this.fileInput = fileInput)
                                    }
                                />
                                <Typography
                                    style={{
                                        marginTop: 24,
                                        fontWeight: "bold",
                                    }}
                                    variant="body2"
                                >
                                    (3) Upload Selected Files
                                </Typography>
                                <Button
                                    style={{
                                        margin: "0 auto",

                                        display: "block",
                                        color:
                                            this.isSubmitDisabled(
                                                currNames,
                                                duplicates
                                            ) || uploadFiles.length === 0
                                                ? "black"
                                                : "white",
                                        width: "100%",
                                        background:
                                            this.isSubmitDisabled(
                                                currNames,
                                                duplicates
                                            ) || uploadFiles.length === 0
                                                ? "lightgrey"
                                                : "#0188cc",
                                    }}
                                    disabled={
                                        this.isSubmitDisabled(
                                            currNames,
                                            duplicates
                                        ) || uploadFiles.length === 0
                                    }
                                    onClick={() => {
                                        this.props.uploadFile(
                                            uploadFiles,
                                            selectedFolder,
                                            (status) => {
                                                console.log(status);
                                                if (status.urls)
                                                    this.setState({
                                                        uploadedFiles:
                                                            status.urls,
                                                    });
                                                else {
                                                    this.setState({
                                                        progress:
                                                            status.inProgress,
                                                        finished:
                                                            status.finished,
                                                        error: status.error,
                                                        msg: status.msg,
                                                    });
                                                }
                                            },
                                            duplicates
                                        );
                                    }}
                                    variant="contained"
                                >
                                    Upload File(s)
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </ModalBody>

                <ModalFooter>
                    <Button
                        variant="contained"
                        onClick={() => {
                            closeFileUploader();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={
                            this.state.uploadedFiles === false &&
                            selectedFiles.length === 0
                        }
                        style={{
                            color:
                                this.state.uploadedFiles === false &&
                                selectedFiles.length === 0
                                    ? "black"
                                    : "white",
                            background:
                                this.state.uploadedFiles === false &&
                                selectedFiles.length === 0
                                    ? "lightgrey"
                                    : "#0188cc",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            let files = false;
                            let uFiles =
                                this.state.uploadedFiles && multipleUploads
                                    ? this.state.uploadedFiles
                                    : this.state.uploadedFiles &&
                                      !multipleUploads
                                    ? this.state.uploadedFiles[0]
                                    : false;

                            if (uFiles && selectedFiles.length === 0) {
                                files = uFiles;
                            } else if (
                                uFiles === false &&
                                selectedFiles.length !== 0
                            ) {
                                files = selectedFiles;
                            } else if (uFiles && selectedFiles.length !== 0) {
                                files = [...selectedFiles, ...uFiles];
                            }

                            this.props.callback(files);

                            closeFileUploader();
                        }}
                    >
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(
    (store) => {
        return {
            files: selectFiles(store),
            folders: selectFolders(store),
            selectedFolder: selectedFolder(store),
            currNames: selectCurrNames(store),
            allFiles: getAllFiles(store)
        };
    },
    { uploadFile, getFiles, getFolders, setFolder }
)(FileUploader);
